import { DateFunctions } from "../static/date-functions";
import { MessageInfo } from "./MessageInfo";
import { MessageInfoType } from "../enums/MessageInfoType";
import { CommonFunctions } from "../static/common-functions";

export class BaseMessageInfo
{
    constructor(data: BaseMessageInfo = null) {
        Object.assign(this, data);
        if (data !== null) {
            this.insertDt = DateFunctions.getDate(data.insertDt);
            this.primaryDate = DateFunctions.getDate(data.primaryDate);
        }
    }
    message: string;
    primaryId: string;
    primaryNumber: string;
    existingNumber: string;
    saveError: boolean;
    warning: boolean;
    existsAlready: boolean;
    notificationChecked: boolean;
    insertDt: Date;
    primaryDate: Date;
    userId: any;
    companyId: any;
    includeInactive: boolean;
    routing: string;
    primaryReturn: any;
    primaryReturnView: any;
    dcValues: any;
    messages: MessageInfo[];
    getMessages(type: MessageInfoType = null) : MessageInfo[] {
        if (type) {
            return this.messages.filter(s => s.messageType === type);
        }
        else {
            return this.messages;
        }
    }
    get hasConfirmMessages(): boolean {
        let hasConfirm = false;
        hasConfirm = this.messages.filter(s => s.messageType === MessageInfoType.confirm).length > 0;
        return hasConfirm;
    }
    get hasNonConfirmMessages(): boolean {
        let hasConfirm = false;
        hasConfirm = this.messages.filter(s => s.messageType !== MessageInfoType.confirm).length > 0;
        return hasConfirm;
    }
    get hasMessages(): boolean {
        return CommonFunctions.hasArrayElementValue(this.messages);
    }
    set hasMessages(value: boolean) { }
    addMessage(msg: MessageInfo) {
        if (!CommonFunctions.hasArrayElementValue(this.messages)) {
            this.messages = [];
        }
        this.messages.push(msg);
    }
    getMessage(msgNum: number = 0) : MessageInfo {
        return this.hasMessages && this.messages.length > msgNum ? this.messages[msgNum] : new MessageInfo();
    }
}
